var React = require('react');

function Marker (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36 18c0 14-18 26-18 26S0 32 0 18c0-4.7739 1.89642-9.35227 5.27208-12.72792C8.64773 1.89642 13.2261 0 18 0c4.7739 0 9.3523 1.89642 12.7279 5.27208C34.1036 8.64773 36 13.2261 36 18z","fill":"#56B3C8","key":0}),React.createElement("path",{"d":"M36 18c0 14-18 26-18 26S0 32 0 18c0-4.7739 1.89642-9.35227 5.27208-12.72792C8.64773 1.89642 13.2261 0 18 0c4.7739 0 9.3523 1.89642 12.7279 5.27208C34.1036 8.64773 36 13.2261 36 18z","fill":"#56B3C8","key":1})]);
}

Marker.defaultProps = {"width":"36","height":"44","fill":"none"};

module.exports = Marker;

Marker.default = Marker;
